(function () {
  if (typeof window !== 'undefined' && window.__swishContactPopupFormScriptLoaded) {
    return;
  }

  if (typeof window !== 'undefined') {
    window.__swishContactPopupFormScriptLoaded = true;
  }

  const MAX_FILE_BYTES = 10 * 1024 * 1024;
  const SUCCESS_MESSAGE = 'Thanks. We received your message. Our team member will contact you within 24 hours.';
  const ERROR_MESSAGE = 'We could not send your message right now. Please try again in a moment.';

  function toArray(list) {
    return Array.prototype.slice.call(list || []);
  }

  function setSourceFields(section) {
    if (!section || typeof window === 'undefined') return;

    const originInput = section.querySelector('[data-contact-page-origin-input]');
    const urlInput = section.querySelector('[data-contact-page-url-input]');
    const fallbackOrigin = section.getAttribute('data-contact-page-origin') || '';
    const fallbackUrl = section.getAttribute('data-contact-page-url') || '';
    const origin = window.location.origin || fallbackOrigin;
    const url = window.location.href || fallbackUrl;

    if (originInput) originInput.value = origin || fallbackOrigin;
    if (urlInput) urlInput.value = url || fallbackUrl;
  }

  function getMessageBox(section) {
    return section ? section.querySelector('[data-contact-upload-message]') : null;
  }

  function showMessage(section, message) {
    const box = getMessageBox(section);
    if (!box) return;

    box.textContent = message || '';
    box.hidden = !message;
  }

  function buildUploadEndpoint(section) {
    if (!section || typeof window === 'undefined') return null;

    const endpoint = String(section.getAttribute('data-contact-upload-endpoint') || '').trim();
    if (!endpoint) return null;

    try {
      return new URL(endpoint, window.location.origin).toString();
    } catch (error) {
      return endpoint;
    }
  }

  function getSubmitButton(form) {
    return form.querySelector('button[type="submit"], input[type="submit"]');
  }

  function syncTrackedValue(field) {
    if (!field || !field.name || !/^contact\[/.test(field.name)) return;

    const type = String(field.type || '').toLowerCase();
    if (type === 'hidden' || type === 'file') {
      return;
    }

    if (type === 'checkbox' || type === 'radio') {
      field.dataset.swishUserValue = field.checked ? String(field.value || '') : '';
      return;
    }

    field.dataset.swishUserValue = String(field.value || '');
  }

  function bindTrackedValues(form) {
    toArray(form.querySelectorAll('input[name^="contact["], textarea[name^="contact["], select[name^="contact["]')).forEach(
      function (field) {
        syncTrackedValue(field);
        field.addEventListener('input', function () {
          syncTrackedValue(field);
        });
        field.addEventListener('change', function () {
          syncTrackedValue(field);
        });
      }
    );
  }

  async function submitToSwishSystem(section, form) {
    const intake = typeof window !== 'undefined' ? window.SwishSystemIntake : null;
    if (!intake || typeof intake.buildStandardFormPayload !== 'function' || typeof intake.postThemePayload !== 'function') {
      throw new Error('The inquiry endpoint is not available.');
    }

    const payload = intake.buildStandardFormPayload({
      form: form,
      section: section,
      source: (section && section.getAttribute('data-swish-system-source')) || 'SHOPIFY_CONTACT',
      formType: (section && section.getAttribute('data-swish-system-form-type')) || 'shopify-contact'
    });

    const result = await intake.postThemePayload(section, payload);
    if (!result || !result.ok) {
      const message = result && (result.error || result.reason || (result.result && result.result.error));
      throw new Error(message || ERROR_MESSAGE);
    }

    return result;
  }

  function haltSubmit(event) {
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
  }

  function clearUploadedValues(form) {
    toArray(form.querySelectorAll('[data-contact-upload-hidden="true"]')).forEach(function (node) {
      node.remove();
    });

    toArray(form.querySelectorAll('[data-contact-upload-input]')).forEach(function (input) {
      input.disabled = false;
    });
  }

  function validateFiles(section, inputs) {
    for (let index = 0; index < inputs.length; index += 1) {
      const input = inputs[index];
      const files = toArray(input.files);

      for (let fileIndex = 0; fileIndex < files.length; fileIndex += 1) {
        const file = files[fileIndex];
        if (file.size > MAX_FILE_BYTES) {
          showMessage(section, '"' + file.name + '" is larger than 10 MB. Please upload a smaller file.');
          return false;
        }
      }
    }

    return true;
  }

  async function uploadFile(endpoint, file) {
    const body = new FormData();
    body.append('file', file);

    const response = await fetch(endpoint, {
      method: 'POST',
      body: body,
      credentials: 'same-origin'
    });

    const payload = await response.json();
    if (!response.ok || !payload || payload.status !== 'success' || !payload.src_file) {
      throw new Error((payload && payload.message) || 'Upload failed.');
    }

    return payload.src_file;
  }

  async function uploadSelectedFiles(section, form) {
    const uploadInputs = toArray(form.querySelectorAll('[data-contact-upload-input]')).filter(function (input) {
      return input.files && input.files.length > 0;
    });

    if (!uploadInputs.length) return true;
    if (!validateFiles(section, uploadInputs)) return false;

    const endpoint = buildUploadEndpoint(section);
    if (!endpoint) {
      showMessage(
        section,
        'A file upload endpoint is not configured for this form. Remove file fields or add an upload endpoint in the form settings.'
      );
      return false;
    }

    for (let index = 0; index < uploadInputs.length; index += 1) {
      const input = uploadInputs[index];
      const files = toArray(input.files);
      const uploadedValues = [];

      for (let fileIndex = 0; fileIndex < files.length; fileIndex += 1) {
        const file = files[fileIndex];
        const uploadedUrl = await uploadFile(endpoint, file);
        uploadedValues.push(file.name + ': ' + uploadedUrl);
      }

      const hiddenField = document.createElement('textarea');
      hiddenField.hidden = true;
      hiddenField.name = input.name;
      hiddenField.value = uploadedValues.join('\n');
      hiddenField.setAttribute('data-contact-upload-hidden', 'true');
      form.appendChild(hiddenField);

      input.disabled = true;
    }

    return true;
  }

  function bindSection(section) {
    const form = section.querySelector('form');
    if (!form || form.dataset.contactPopupFormBound === 'true') return;

    form.dataset.contactPopupFormBound = 'true';
    setSourceFields(section);
    bindTrackedValues(form);

    toArray(form.querySelectorAll('[data-contact-upload-input]')).forEach(function (input) {
      input.addEventListener('change', function () {
        showMessage(section, '');
      });
    });

    form.addEventListener(
      'submit',
      async function (event) {
        const notifier = typeof window !== 'undefined' ? window.SwishShopifyCaptcha : null;
        if (notifier && typeof notifier.shouldAllowNativeSubmit === 'function' && notifier.shouldAllowNativeSubmit(form)) {
          return;
        }

        if (form.dataset.contactUploadInFlight === 'true') {
          haltSubmit(event);
          return;
        }

        setSourceFields(section);
        clearUploadedValues(form);
        showMessage(section, '');

        haltSubmit(event);

        const submitButton = getSubmitButton(form);
        form.dataset.contactUploadInFlight = 'true';
        if (submitButton) submitButton.disabled = true;

        try {
          const uploaded = await uploadSelectedFiles(section, form);
          if (!uploaded) return;
          await submitToSwishSystem(section, form);
          showMessage(section, SUCCESS_MESSAGE);
        } catch (error) {
          showMessage(section, (error && error.message) || ERROR_MESSAGE);
        } finally {
          form.dataset.contactUploadInFlight = 'false';
          if (submitButton) submitButton.disabled = false;
        }
      },
      true
    );
  }

  function init(root) {
    const scope = root && root.querySelectorAll ? root : document;
    const sections = [];

    if (
      scope.matches &&
      (scope.matches('[data-contact-popup-form-section]') || scope.matches('[data-contact-builder-form-section]'))
    ) {
      sections.push(scope);
    }

    toArray(scope.querySelectorAll('[data-contact-popup-form-section]')).forEach(function (section) {
      sections.push(section);
    });

    toArray(scope.querySelectorAll('[data-contact-builder-form-section]')).forEach(function (section) {
      sections.push(section);
    });

    sections.forEach(bindSection);
  }

  function scheduleInit(root) {
    if (typeof window !== 'undefined' && typeof window.requestAnimationFrame === 'function') {
      window.requestAnimationFrame(function () {
        init(root);
      });
      return;
    }

    setTimeout(function () {
      init(root);
    }, 0);
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      function () {
        init(document);
      },
      { once: true }
    );
  } else {
    scheduleInit(document);
  }

  document.addEventListener('shopify:section:load', function () {
    scheduleInit(document);
  });
})();
